export default __webpack_public_path__ + "static/media/Seegrid 2.4b03ef4e.png";